import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import { DropAlert } from '../DropAlert'
import { DropPaper } from '../DropPaper'
import MainButton from '../../common/util/input/MainButton'
import SelectElement from '../../common/util/SelectElement'
import { SelectItem } from '@nextui-org/react'

export const BlockAttributeRule = ({
    rules,
    setRules,
    ruleIndex,
    attributes,
    selectedBlockAttributesAttribute,
    setDuplicatedRuleError,
    setDuplicatedAttributeError,
}) => {
    const addBlackListItem = () => {
        const temp = [...rules]
        const rule = temp[ruleIndex]
        rule.attribute_blacklist.push({ attribute_name: '', value: '' })
        setRules(temp)
    }

    const deleteBlackListItem = (index) => {
        const temp = [...rules]
        const rule = temp[ruleIndex]
        const blacklist = rule.attribute_blacklist
        blacklist.splice(index, 1)
        setRules(temp)
    }

    const deleteRule = () => {
        const temp = [...rules]
        temp.splice(ruleIndex, 1)
        setRules(temp)
    }

    const getListOfAttributeNames = () => {
        const list = []

        for (const attribute of attributes) {
            if (attribute.attribute_name !== selectedBlockAttributesAttribute) {
                list.push(attribute.attribute_name)
            }
        }

        return list
    }

    const isDuplicateRule = () => {
        const rulesForAttributeValue = rules.filter(
            (rule) =>
                rule.base_attribute.attribute_name ===
                    rules[ruleIndex].base_attribute.attribute_name &&
                rule.base_attribute.value ===
                    rules[ruleIndex].base_attribute.value,
        )

        if (rulesForAttributeValue.length > 1) {
            setDuplicatedRuleError('Duplicate rules detected!')
            return true
        } else {
            setDuplicatedRuleError(null)
            return false
        }
    }

    const hasDuplicateValues = () => {
        const blackList = rules[ruleIndex].attribute_blacklist
        const blackListItems = []
        for (const item of blackList) {
            blackListItems.push(item.attribute_name + '-' + item.value)
        }
        if (new Set(blackListItems).size !== blackListItems.length) {
            setDuplicatedAttributeError(
                'Duplicate Attribute Instances detected!',
            )
            return true
        } else {
            setDuplicatedAttributeError(null)
            return false
        }
    }

    const getListOfAttributeValueNames = (attributeName) => {
        const list = []

        const targetAttribute = attributeName
            ? attributeName
            : selectedBlockAttributesAttribute

        const attribute = attributes.find(
            (element) => element.attribute_name === targetAttribute,
        )

        if (attribute) {
            for (const entry of attribute.possible_values) {
                list.push(entry.value)
            }
        }
        return list
    }

    const AttributeValuePair = ({ index }) => {
        return (
            <DropPaper noMargin className="my-2" error={hasDuplicateValues()}>
                <div className="flex flex-wrap">
                    <div className="w-40 mx-2 my-auto">
                        <SelectElement
                            disallowEmptySelection
                            label="Select Attribute"
                            variant="bordered"
                            classNames={{
                                label: 'text-black font-semibold dark:text-white',
                                errorMessage:
                                    'text-red-500 dark:text-red-500 font-semibold text-left mt-1',
                                input: 'text-black font-semibold dark:text-white',
                            }}
                            placeholder="Select an option"
                            selectedKeys={
                                new Set([
                                    rules[ruleIndex].attribute_blacklist[index]
                                        .attribute_name,
                                ])
                            }
                            onChange={(e) => {
                                if (e.target.value) {
                                    const temp = [...rules]
                                    const blackList =
                                        temp[ruleIndex].attribute_blacklist
                                    blackList[index].attribute_name =
                                        e.target.value
                                    setRules(temp)
                                }
                            }}
                        >
                            {getListOfAttributeNames().map((AttributeName) => (
                                <SelectItem
                                    key={AttributeName}
                                    value={AttributeName}
                                >
                                    {AttributeName}
                                </SelectItem>
                            ))}
                        </SelectElement>
                    </div>
                    <div className="w-40 mx-2 my-auto">
                        <SelectElement
                            disallowEmptySelection
                            label="Select Instance"
                            variant="bordered"
                            classNames={{
                                label: 'text-black font-semibold dark:text-white',
                                errorMessage:
                                    'text-red-500 dark:text-red-500 font-semibold text-left mt-1',
                                input: 'text-black font-semibold dark:text-white',
                            }}
                            placeholder="Select an option"
                            selectedKeys={
                                new Set([
                                    rules[ruleIndex].attribute_blacklist[index]
                                        .value,
                                ])
                            }
                            onChange={(e) => {
                                const temp = [...rules]
                                const blackList =
                                    temp[ruleIndex].attribute_blacklist
                                blackList[index].value = e.target.value
                                setRules(temp)
                            }}
                            isDisabled={
                                rules[ruleIndex].attribute_blacklist[index]
                                    .attribute_name === ''
                            }
                        >
                            {getListOfAttributeValueNames(
                                rules[ruleIndex].attribute_blacklist[index]
                                    .attribute_name,
                            ).map((attributeName) => (
                                <SelectItem
                                    key={attributeName}
                                    value={attributeName}
                                >
                                    {attributeName}
                                </SelectItem>
                            ))}
                        </SelectElement>
                    </div>
                    <div className="mx-2 my-auto">
                        <IconButton
                            onClick={() => deleteBlackListItem(index)}
                            color="error"
                            size="small"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                </div>
            </DropPaper>
        )
    }

    if (
        rules[ruleIndex] === undefined ||
        rules[ruleIndex].base_attribute.attribute_name !==
            selectedBlockAttributesAttribute
    ) {
        return null
    } else
        return (
            <DropPaper noMargin className="my-3" error={isDuplicateRule()}>
                <div className="flex flex-wrap mb-5">
                    <div className="my-auto mr-2">If</div>
                    <div className="w-40">
                        <SelectElement
                            disallowEmptySelection
                            label="Select Instance"
                            variant="bordered"
                            classNames={{
                                label: 'text-black font-semibold dark:text-white',
                                errorMessage:
                                    'text-red-500 dark:text-red-500 font-semibold text-left mt-1',
                                input: 'text-black font-semibold dark:text-white',
                            }}
                            placeholder="Select Instance"
                            selectedKeys={
                                new Set([rules[ruleIndex].base_attribute.value])
                            }
                            onChange={(e) => {
                                const temp = [...rules]
                                rules[ruleIndex].base_attribute.value =
                                    e.target.value
                                setRules(temp)
                            }}
                        >
                            {getListOfAttributeValueNames().map(
                                (attributeName) => (
                                    <SelectItem
                                        key={attributeName}
                                        value={attributeName}
                                    >
                                        {attributeName}
                                    </SelectItem>
                                ),
                            )}
                        </SelectElement>
                    </div>
                    <div className="my-auto ml-2">
                        has been picked, the following must not be picked:
                    </div>
                </div>
                {rules[ruleIndex].attribute_blacklist.map((item, index) => (
                    <AttributeValuePair index={index} />
                ))}
                <DropAlert severity="error" condition={hasDuplicateValues()}>
                    Duplicate Attribute Instances detected!
                </DropAlert>
                <div className="flex flex-wrap mt-5">
                    <div className="mx-2 w-36">
                        <MainButton
                            fullWidth
                            disabled={
                                rules[ruleIndex].value === '' ||
                                isDuplicateRule() ||
                                hasDuplicateValues()
                            }
                            onClick={() => addBlackListItem()}
                            endContent={<AddCircleOutlineOutlinedIcon />}
                        >
                            Add Item
                        </MainButton>
                    </div>
                    <div className="mx-2 w-36">
                        <MainButton
                            fullWidth
                            color="danger"
                            onClick={() => deleteRule()}
                            endContent={<DeleteIcon />}
                        >
                            {' '}
                            Delete Rule
                        </MainButton>
                    </div>
                </div>
                <DropAlert severity={'error'} condition={isDuplicateRule()}>
                    Duplicate rules for instance{' '}
                    <b>{rules[ruleIndex].base_attribute.value}</b>
                </DropAlert>
            </DropPaper>
        )
}
